import React from 'react';
import MessageStatus from './MessageStatus';
import MediaPreview from './MediaPreview';
import styles from '../../WabaChats.module.scss';

function formatTime(isoString) {
    if (!isoString) return '';
    return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

export default function MessageBubble({ message, branchId, onDismiss }) {
    const isOutbound = message.direction === 'outbound';
    const isFailed = message.status === 'failed';
    const hasMedia = ['image', 'video', 'audio', 'document', 'sticker'].includes(message.type);

    const bubbleClasses = [
        styles.bubble,
        isOutbound ? styles.bubbleOutbound : styles.bubbleInbound,
        isFailed ? styles.bubbleFailed : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={`${styles.bubbleRow} ${isOutbound ? styles.bubbleRowRight : ''}`}>
            <div className={bubbleClasses}>
                {isFailed && onDismiss && (
                    <button className={styles.dismissBtn} onClick={() => onDismiss(message.id)} title="Dismiss failed message">
                        &times;
                    </button>
                )}
                {hasMedia && <MediaPreview message={message} branchId={branchId} />}
                {message.content?.body && <div className={styles.bubbleText}>{message.content.body}</div>}
                {message.content?.caption && !message.content?.body && <div className={styles.bubbleText}>{message.content.caption}</div>}
                {message.type === 'location' && message.content && (
                    <div className={styles.bubbleText}>
                        Location: {message.content.latitude}, {message.content.longitude}
                    </div>
                )}
                <div className={styles.bubbleMeta}>
                    <span className={styles.bubbleTime}>{formatTime(message.timestamp)}</span>
                    {isOutbound && <MessageStatus status={message.status} />}
                </div>
            </div>
        </div>
    );
}
